// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/laptop.js';

import { paths } from '../generated/laptop';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('laptop', Original, paths);
